import React, { useEffect, useState } from 'react'
import { Typography, Box, RadioGroup, FormControl } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { kaihoAdminLan } from '~/src/libs/i18next/config'
import { useMessage } from '~/src/hooks'
import { ProtectedPage } from '~/src/components/templates'
import { CardWithActionButton } from '~/src/components/organisms'
import { RadioForm } from '~/src/components/molecules'

const DEFAULT_LANGUAGE = 'ja'
/**
 * CurrencySetting Page
 * @param __namedParameters
 * @returns JSX.Element
 * @category ReactComponents
 */
export const LanguageSetting = () => {
  const { t, i18n } = useTranslation()
  const { handleOpenWithSuccessMessage } = useMessage()
  const [loading, setLoading] = useState<boolean>(false)
  const [languageValue, setLanguageValue] = useState<'en' | 'ja' | string>('')

  const getStorage = async () => {
    const res = (await localStorage.getItem(kaihoAdminLan)) as string | null
    if (res) {
      const l = res === 'en-US' ? 'en' : res
      setLanguageValue(l)
    } else {
      setLanguageValue(DEFAULT_LANGUAGE)
    }
  }

  useEffect(() => {
    getStorage()
  }, [])

  /**
   * handleChange
   * @param event {React.ChangeEvent<HTMLInputElement>}
   */
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLanguageValue((event.target as HTMLInputElement).value)
  }

  /**
   * changeLanguage
   */
  const changeLanguage = () => {
    setLoading(true)
    setTimeout(() => {
      i18n.changeLanguage(languageValue)
      setLoading(false)
      window.location.reload()
      handleOpenWithSuccessMessage('Success!!')
      // navigate(location, { replace: true })
    }, 1000)
  }

  return (
    <ProtectedPage pageTitle={t('page_title.settings_currency')}>
      <CardWithActionButton handleClick={changeLanguage} loading={loading}>
        <Box display={'flex'} alignItems={'flex-start'} marginTop={-1}>
          <Typography variant="body2" component="h3" paddingY={'9px'}>
            {t('section_title.settings_currency')}
          </Typography>
          <Box marginLeft={3.75}>
            <FormControl>
              <RadioGroup
                defaultValue={DEFAULT_LANGUAGE}
                name="radio-buttons-group"
                value={languageValue}
                onChange={handleChange}
              >
                <RadioForm value={'ja'} label={t('section_title.japanese')} />
                <RadioForm value={'en'} label={t('section_title.english')} />
              </RadioGroup>
            </FormControl>
          </Box>
        </Box>
      </CardWithActionButton>
    </ProtectedPage>
  )
}
